import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { matchKpisQueryOptions } from "@/api/ranking";
import { useSelectedMatch } from "@/context/matchContext";
import { useSelectedTeam } from "@/context/teamContext";
import { ShotHeatMap } from "@/components/general/Dashboard/Overview/ShotHeatMap";

export const HeatmapPage = () => {
    const { matchIds, setTournamentName } = useSelectedMatch();
    const { teamId } = useSelectedTeam();

    const { data: kpiData, isLoading } = useQuery(
        matchKpisQueryOptions(matchIds.length > 0 ? matchIds : undefined, teamId)
    );

    useEffect(() => {
        if (kpiData?.matches && kpiData.matches.length > 0) {
            setTournamentName(kpiData.matches[0].tournamentName);
        }
    }, [kpiData, setTournamentName]);

    return (
        <div className="flex-1 min-h-0 h-full flex flex-col overflow-hidden">
            <div className="w-full">
                <ShotHeatMap
                    matchIds={matchIds.length > 0 ? matchIds : undefined}
                    className="w-full"
                    isLoading={isLoading}
                />
            </div>
        </div>
    );
};
